import { Box, Heading, Text, List, ListItem } from '@chakra-ui/react'

const QuickStart = () => (
  <Box>
    <Heading as="h3" size="lg" mb={3} color="brand.secondary">
      Quick-Start Implementation Guide
    </Heading>
    <List spacing={2} styleType="decimal" pl={5}>
      <ListItem><Text fontSize="sm"><b>Track the Ratio:</b> Monitor the Good/Very Bad sentiment ratio daily (Good sentiment divided by Very Bad sentiment).</Text></ListItem>
      <ListItem><Text fontSize="sm"><b>Buy Signal:</b> Enter when ratio is above 1.0 and rising. Invest 75% of your capital.</Text></ListItem>
      <ListItem><Text fontSize="sm"><b>Sell Signal:</b> Exit when ratio falls below 1.0 or drops significantly from a peak. Sell your entire position.</Text></ListItem>
      <ListItem><Text fontSize="sm"><b>Risk Management:</b> Use 8% stop losses below entry prices and aim for 15% profit targets.</Text></ListItem>
      <ListItem><Text fontSize="sm"><b>Position Management:</b> Hold your position as long as the ratio remains above 1.0, even if it fluctuates.</Text></ListItem>
      <ListItem><Text fontSize="sm"><b>Follow these rules consistently,</b> track your trades in a spreadsheet, and don't override the signals based on emotions.</Text></ListItem>
    </List>
  </Box>
)

export default QuickStart
